import { useStoreState } from "../../../store/hooks";
import { Tenant } from "../../tenant/models";

export const useTenant = (): Tenant | null => {
    return useStoreState((state) => state.auth.currentTenant);
};
